import { action } from 'satcheljs';
export default action('updateUserConfigurationPont', function (pontType) {
    return {
        pontType: pontType,
    };
});
//# sourceMappingURL=updateUserConfigurationPont.js.map